// ROGA VARIABLES

export const clientId = () => {
  switch (location.hostname) {
    case "localhost":
      return "6ff5ca6d7852f7fee90ed80c12716a8499c7a3ef4acf8edf2dffb75ab71c745e";
    case "homologacao.docgo.com.br":
      return "ed487e923a6d11d69d01736c992583ba7f5b4ad12ef9863b934c88b6541fea11";
    case "ima.docgo.com.br":
      return "f6f4307c3f13b453339b1950a4d2fd10c9ec73cb078b94700e4779dfddc384fa";
    case "homolog.ima.docgo.com.br":
      return "f8da189e1b080484c15890f3e544e254c316c723804df9bd89ea438397548686";
    case "penedo.docgo.com.br":
      return "f2ecd1692dd7c4a1a866198621a5ca28da8e891b577629b29a8549b262067bd8";
    case "homolog.docgo.com.br":
      return "4f0b8a815c794b3642c8c03eda5a53449fe602179b8ddd40b6ac2ac6ea3110ae";
    case "marechal.docgo.com.br":
      return "32b24142e3260dae36baf718f1cb3a286208be00cdeb205de4f224865bd7abcd";
    case "teotonio.docgo.com.br":
      return "5a4ce20597178297fb72822910f831d4b605df1c8cf05aaa7c57a0efb6d7439d";
    default:
      return "6ff5ca6d7852f7fee90ed80c12716a8499c7a3ef4acf8edf2dffb75ab71c745e";
  }
};

export const redirectUri = () => {
  switch (location.hostname) {
    case "localhost":
      return "http://localhost:8080/autenticacao/callback";
    case "homologacao.docgo.com.br":
      return "https://homologacao.docgo.com.br/autenticacao/callback";
    case "ima.docgo.com.br":
      return "https://ima.docgo.com.br/autenticacao/callback";
    case "homolog.ima.docgo.com.br":
      return "https://homolog.ima.docgo.com.br/autenticacao/callback";
    case "penedo.docgo.com.br":
      return "https://penedo.docgo.com.br/autenticacao/callback";
    case "homolog.docgo.com.br":
      return "https://homolog.docgo.com.br/autenticacao/callback";
    case "marechal.docgo.com.br":
      return "https://marechal.docgo.com.br/autenticacao/callback";
    case "teotonio.docgo.com.br":
      return "https://teotonio.docgo.com.br/autenticacao/callback";
    default:
      return "https://localhost:8080/autenticacao/callback";
  }
};



// WEBPACK FOOTER //
// ./src/constants/API_SIGN_GO.js